module.exports = __webpack_public_path__ + "img/00—02—Password recovery—IBstandard.874fade9.jpg";